import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetHubs } from '../../store/hubs'
import { hubExportColumns } from '../../config/exportColumns/hubExportColumns'
import { useDispatch } from 'react-redux'

function HubSetup() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Communities</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appAllGetHubs({ ...params, loading: false }))}
							columns={hubExportColumns}
							fileName="Community_List"
							sheetName="Communities"
							buttonText="Export Communities"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/community-setup/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Community
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default HubSetup
